import { render, staticRenderFns } from "./Ethics.vue?vue&type=template&id=779b5c86&"
import script from "./Ethics.vue?vue&type=script&lang=js&"
export * from "./Ethics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports